import { create } from 'zustand';
import { Settings, SettingsField, SettingsStore } from './types';
import { getStoredSettings, saveSettings } from './storage';
import { LANGUAGES } from './default-data';

export const useSettingsStore = create<SettingsStore>((set, get) => ({
  settings: getStoredSettings(),

  updateSetting: <K extends SettingsField>(field: K, value: Settings[K]) => {
    // Language switching is locked: only enabled catalog languages can be set.
    if (field === "language") {
      const language = LANGUAGES.find((lang) => lang.id === value);
      if (!language || !language.enabled) {
        return;
      }
    }

    const currentSettings = get().settings;
    const updatedSettings = {
      ...currentSettings,
      [field]: value,
    };

    // Update store
    set({ settings: updatedSettings });

    // Save to localStorage
    saveSettings(updatedSettings);
  },

  getSetting: <K extends SettingsField>(field: K): Settings[K] => {
    return get().settings[field];
  },

  loadSettings: () => {
    const settings = getStoredSettings();
    set({ settings });
  },
}));
